export const days = [
  "MONDAY",
  "TUESDAY",
  "WEDNESDAY",
  "THURSDAY",
  "FRIDAY",
  "SATURDAY",
  "SUNDAY",
];
export const tasks = ["INDUCT", "SORT", "STAGE"];
export const timeBreaks = ["BREAK1", "LUNCH", "BREAK2"];
export const taskPlan = "taskPlan";
export const breaks = "breaks";
export const induct = "INDUCT";
export const sort = "SORT";
export const stage = "STAGE";
export const break1 = "BREAK1";
export const lunch = "LUNCH";
export const break2 = "BREAK2";
export const startTime = "startTime";
export const endTime = "endTime";
export const targetMap = "targetMap";
export const NODE_TPH = "NODE_TPH";
export const INDUCT_PPH = "INDUCT_PPH";
export const STOW_PPH = "STOW_PPH";
export const dayMaxHour = 23;
export const dayMinHour = 0;
export const stringDay = "January 1, 2020 ";
export const MODAL_RESET = "RESET";
export const MODAL_SUCCESS = "SUCCESS";
export const MODAL_ERROR = "ERROR";
export const RESET_TIME_OVERLAP = "overlap_with_reset_time";
export const stringNextDay = "January 2, 2020 ";
export const MISSING_MANDATORY_FIELD = "configure_plan";



// WEBPACK FOOTER //
// ./src/components/settings/SettingsConstant.js